
webpack.register(
    'modules/hole-detail/hole-detail',
    function() {
        return import('modules/hole-detail/hole-detail');
    },
    true
);